// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__3g5q7","Open":"SideDrawer_Open__13OR0","Close":"SideDrawer_Close__3ZamH","Logo":"SideDrawer_Logo__3jtxZ"};